import React from 'react';
import { THEME_MODE, MESSAGES_THEME } from '../containers/App/constants';
import ekycMessages from '../containers/EkycPage/messages';

export const maxInputLengthHelper = length => ({
  onInput(e) {
    e.target.value = e.target.value.slice(0, length);
  },
  onWheel(e) {
    e.target.blur();
    setTimeout(function() {
      e.target.focus();
    }, 0);
    return false;
  },
});

export const InputWithNoSpaces = () => ({
  onKeyDown(e) {
    if (e.key === ' ') {
      e.preventDefault();
    }
  },
});

// Build a map of theme images using Vite's import.meta.glob
const themeImages = import.meta.glob('../images/**/*.(png|jpg|svg)', { eager: true });

export const getLogoAsPerTheme = (theme, logoName) => {
  const key = `../images/${theme}/${logoName}`;
  const match = themeImages[key];
  if (match) {
    return match.default || match;
  }
  return '';
};

export const setMessagesAsPerTheme = theme => {
  switch (theme) {
    case THEME_MODE[6]:
      ekycMessages.header.defaultMessage =
        MESSAGES_THEME.AMAZON_NEW.EkycPage.header.defaultMessage;
      break;
  }
};

export const getErrorIconAsPerTheme = (theme, additionalText) => {
  switch (theme) {
    case THEME_MODE[2]:
    case THEME_MODE[3]:
    case THEME_MODE[4]:
      return [
        <div className="material-icons md12 marRight4">info</div>,
        additionalText,
      ];
    default:
      return [additionalText, <span>!</span>];
  }
};
